<template>
    <div>
        <vapp-header btnBack></vapp-header>
        <div class="container" style="padding-top: 15px">
            <div class="row">
                <div class="col-md-12">
                    <ul class="data-list">
                        <li v-for="(account, index) in accounts" :key="index" @click="pushItem(account)">
                            <div class="data-circle">
                                <span>{{ account.name.charAt(0).toUpperCase() }}</span>
                            </div>
                            <span>{{ account.name }}</span>
                            <hr>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import * as $$ from "lodash";
    import listSvc from '../../services/listService'
    import { mapState, mapActions } from 'vuex';
    export default {
        name: "SelectAccountFromList",
        data: () => ({
            accounts: []
        }),
        computed: {
            ...mapState('company', ['selectedCompany']),
            ...mapState('invoice', ['createInvoiceObj'])
        },
        methods : {
            ...mapActions('invoice', ['setCreateInvoiceObj']),
            pushItem(item) {
                let itemsToPush = {
                    account_id: item.id,
                    name: item.name,
                    quantity: 1,
                    unit_price: 0,
                    display_name: item.name
                };
                if (this.createInvoiceObj.items === undefined){
                    itemsToPush.line = 1
                } else {
                    itemsToPush.line = this.createInvoiceObj.items.length + 1;
                }
                this.setCreateInvoiceObj({ items: itemsToPush })
                this.$router.go(-1)
            },
            async readAccounts () {
                let accountsData = [];
                let data = {
                    "requests": [{
                        "params" : {
                            "company_id" : this.selectedCompany
                        },
                        "uri" : "/lists/accounts"

                    }]
                };
                listSvc.methods.readMixed(data).then( data => {
                    $$.each(data.accounts, function(account) {
                        $$.each(account.items, function (item,) {
                            accountsData.push(item);
                        });
                    });
                    this.accounts = accountsData;
                });
            }
        },
        mounted () {
            console.log("Mounted : Select Account From List");
            this.readAccounts()
        }
    }
</script>

